"use client";

import { createContext, useContext, useState } from "react";
import { AiComments, AiChat, AiToolBar, AiReport, AiVersionDescription, AiContinueWriting } from "@/src/helpers/aiService";

const AiServiceContext = createContext();

export const AiServiceProvider = ({ children }) => {
  const AiCommentsService = AiComments.getInstance();
  const AiChatService = AiChat.getInstance();
  const AiToolBarService = AiToolBar.getInstance();
  const AiReportService = AiReport.getInstance();
  const AiVersionDescriptionService = AiVersionDescription.getInstance();
  const AiContinueWritingService = AiContinueWriting.getInstance();
  const [streamingStatus, setStreamingStatus] = useState({});

  const updateStreamingStatus = (key, status) => {
    setStreamingStatus((prevStatus) => ({ ...prevStatus, [key]: status }));
  };

  AiChatService.setStreamingStatusChangeCallback(updateStreamingStatus);
  AiCommentsService.setStreamingStatusChangeCallback(updateStreamingStatus);
  AiReportService.setStreamingStatusChangeCallback(updateStreamingStatus);
  AiToolBarService.setStreamingStatusChangeCallback(updateStreamingStatus);

  return (
    <AiServiceContext.Provider
      value={{
        AiCommentsService,
        AiChatService,
        AiReportService,
        AiToolBarService,
        AiVersionDescriptionService,
        AiContinueWritingService,
        streamingStatus,
      }}
    >
      {children}
    </AiServiceContext.Provider>
  );
};

export const useAiService = () => {
  const context = useContext(AiServiceContext);
  if (!context) {
    throw new Error("useAiService must be used within a AiServiceProvider");
  }
  return context;
};
